export class ScenarioGroup {
  id: string;
  name: string;
  projectId: number;
  modelRunId: string;
  assignedScenarios: string[];
  createdBy: string;
}
